import { FunctionComponent, useCallback } from "react";
import { useTranslation } from "react-i18next";

import { Modal } from "@/components/Modals/Modal";
import { ButtonColor } from "@/components/Button/types";

interface ArchiveWizardModalProps {
	isOpened: boolean;
	isLoading?: boolean;
	onCancel: () => void;
	onConfirm: () => void;
}

/**
 * Asks before a session is archived (BCM360-375). It says the three things decided on
 * 2026-09-30: nothing is deleted and the costs stay recorded, an intro video already
 * linked stays on the scenario, and the next start is a new, empty wizard.
 */
export const ArchiveWizardModal: FunctionComponent<ArchiveWizardModalProps> = ({
	isOpened,
	isLoading,
	onCancel,
	onConfirm,
}) => {
	const { t } = useTranslation();
	const ts = useCallback((key: string) => t(`videoWizard.archive.${key}`), [t]);

	return (
		<Modal
			cancelButtonText={ts("cancel")}
			handleClose={onCancel}
			handleSave={onConfirm}
			isLoading={isLoading}
			isOpened={isOpened}
			size="sm"
			submitButtonColor={ButtonColor.DANGER}
			submitButtonText={ts("confirm")}
			title={ts("title")}
		>
			<div className="space-y-3 text-sm text-text">
				<p>{ts("body")}</p>
				<ul className="list-disc space-y-1 pl-5 text-xs text-subtle">
					<li>{ts("costsRemain")}</li>
					<li>{ts("introStays")}</li>
					<li>{ts("newStart")}</li>
				</ul>
			</div>
		</Modal>
	);
};
